<template>
    <div class="popover-wrapper">
        <div class="trigger"
            :class="{
                'icon-info-filled': styleFilled,
                'icon-info-outline': !styleFilled}"
            v-on:click.stop
        ></div>
    </div>
</template>

<script>
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import 'tippy.js/animations/scale-subtle.css';

export default {
    props: {
        text: String,
        styleFilled: false
    },
    mounted() {
        let trigger = this.$el.querySelector(".trigger");
        let content = document.createElement('div');
        content.innerHTML = this.text;

        tippy(trigger, {
            content: content,
            theme: 'light',
            animation: 'scale-subtle'
        });
    },
};
</script>
